import { forwardRef } from 'react'
import { IconProps } from 'blaze-ui/icons/Types'

export const SelectedTriangle = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor' }, forwardedRef) => {
  return (
    <svg width="33" height="7" viewBox="0 0 33 7" fill="none" xmlns="http://www.w3.org/2000/svg" ref={forwardedRef}>
      <path
        d="M12.7027 1.90485C14.591 0.243858 17.4191 0.24386 19.3074 1.90485L20.8512 3.26277C23.5894 5.67142 27.1114 7 30.7582 7H32.8472H0.847168H1.2519C4.89876 7 8.42071 5.67142 11.159 3.26277L11.4577 3L12.7027 1.90485Z"
        fill={color}
      />
    </svg>
  )
})

export default SelectedTriangle
